import Axios from "axios";
import { IGetCategoriesResponse, IGetLoanTemplateCategoriesResponse, IGetStoreInfoResponse, IGetLoanTemplateCategoriesRequest, IGetStoresInfoRequest, IGetStoresRequest, IGetStoresResponse, IGetLoanTemplateStoresrequest, IGetLoanTemplateStoresResponse } from "../models/store.model";
import { ApiResultModel } from "../models/common.model";
import { APIBASE_URL, STORE_URL } from "../config/cacheKey";

export const GetCategories = async (
    data: { walletKey?: string }
): Promise<IGetCategoriesResponse[]> => {
    return await Axios.post<ApiResultModel<IGetCategoriesResponse[]>>(
        APIBASE_URL + STORE_URL + "/GetCategories",
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetAllCategories = async (
    data: { walletKey?: string }
): Promise<IGetCategoriesResponse[]> => {
    return await Axios.post<ApiResultModel<IGetCategoriesResponse[]>>(
        APIBASE_URL + STORE_URL + "/GetAllCategories",
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetStores = async (
    data: IGetStoresRequest
): Promise<IGetStoresResponse> => {
    return await Axios.post<ApiResultModel<IGetStoresResponse>>(
        APIBASE_URL + STORE_URL + "/GetStores",
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetStoreInfo = async (
    data: IGetStoresInfoRequest
): Promise<IGetStoreInfoResponse> => {
    return await Axios.post<ApiResultModel<IGetStoreInfoResponse>>(
        APIBASE_URL + STORE_URL + "/GetStoreInfo",
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetLoanTemplateCategories = async (
    data: IGetLoanTemplateCategoriesRequest
): Promise<IGetLoanTemplateCategoriesResponse[]> => {
    return await Axios.post<ApiResultModel<IGetLoanTemplateCategoriesResponse[]>>(
        APIBASE_URL + STORE_URL + "/GetLoanTemplateCategories",
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetLoanTemplateStores = async (
    data: IGetLoanTemplateStoresrequest
): Promise<IGetLoanTemplateStoresResponse> => {
    return await Axios.post<ApiResultModel<IGetLoanTemplateStoresResponse>>(
        APIBASE_URL + STORE_URL + "/GetLoanTemplateStores",
        data
    ).then((result) => {
        return result.data.data;
    });
};

